import React from 'react';
import HeroSection from '../components/HeroSection';
import TechNeedSection from '../components/TechNeedSection';
import GlimpseSection from '../components/GlimpseSection';
import CurriculumSection from '../components/CurriculumSection';
import WhyJoinSection from '../components/WhyJoinSection';
import SummerCampPopup from '../components/SummerCampPopup';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home">
      <HeroSection />
      <TechNeedSection />
      <GlimpseSection />
      <CurriculumSection />
      <WhyJoinSection />
      <SummerCampPopup />
    </div>
  );
};

export default Home;
